import React from 'react';
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer';
import { DocLayout } from '../components/DocLayout';
export var pageQuery = "4047657334";
export default function Page(_ref) {
  var mdx = _ref.data.mdx;
  return /*#__PURE__*/React.createElement(DocLayout, {
    title: mdx.fields.title,
    tableOfContents: mdx.tableOfContents,
    editLink: mdx.fields.editLink
  }, /*#__PURE__*/React.createElement(MDXRenderer, null, mdx.body));
}